const userAgreement = {
  path: 'userAgreement',
  component: resolve => require(['../../../pages/userAgreement'], resolve)
}

export default userAgreement
